import React from 'react';
import { OdoroWordmark } from './OdoroWordmark';

/// The logo slot above the auth card: the clinic's logo takes the place of the odoro
/// wordmark, which stays as the fallback for a clinic with no logo on CAL4.
export const AuthLogo = ({ url }) => {
    return url ? <img className={"recordAuthLogo"} src={url} alt={'לוגו המרפאה'} /> : <OdoroWordmark />;
}
